import {useRouter} from 'next/router'
import type {ReactNode} from 'react'
import {memo, useEffect, useState} from 'react'
import type {ButtonVariants} from 'src/common/Button'
import {Button} from 'src/common/Button'
import {getLanguageCode, LEAD_FUNNEL_URL_PRODUCTION, LEAD_FUNNEL_URL_STAGING} from 'src/common/utils/locale'

type ActionButtonProps = {
  className?: string
  children: ReactNode
  isOutline?: boolean
  kind: 'demo' | 'login'
  'data-page-location'?: string
  'data-page-name'?: string
  variant?: ButtonVariants
  id?: string
}

const FUNNEL_URLS = {
  STAGING: LEAD_FUNNEL_URL_STAGING,
  PRODUCTION: LEAD_FUNNEL_URL_PRODUCTION,
}

export const ActionButton = memo(function (props: ActionButtonProps) {
  const {locale} = useRouter()
  const [href, setHref] = useState('/')
  const [dataMktgId, setDataMktgId] = useState('book-demo-button')
  const v1Variant = props.isOutline ? 'outlineV2' : 'fillV2'

  // Sets href
  useEffect(() => {
    const isProduction = window.location.host.includes('getmoss.com')
    const lang = getLanguageCode(locale)

    switch (props.kind) {
      case 'demo': {
        const base = isProduction ? FUNNEL_URLS.PRODUCTION : FUNNEL_URLS.STAGING
        setHref(`${base}?lang=${lang}`)
        setDataMktgId('book-demo-button')
        break
      }

      case 'login': {
        setHref(isProduction ? 'https://getmoss.com/login' : 'https://webapp.internal.runmoss.run/login')
        setDataMktgId('login-button')
        break
      }
    }
  }, [props.kind, locale])

  return (
    <Button
      className={props.className}
      href={href}
      variant={props.variant || v1Variant}
      data-mktg-id={dataMktgId}
      data-page-location={props['data-page-location']}
      {...(props['data-page-name'] && {'data-page-name': props['data-page-name']})}
      {...(props.id && {id: props.id})}
    >
      {props.children}
    </Button>
  )
})
